<template>
  <el-dialog
      v-el-drag-dialog
      append-to-body
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="打印标签条码"
      class="materialCodeModal"
      width="400px"
      top="1vh">
    <div id="printMaterialCodeContent3">
      <div v-for="(item, index) in tableData" id="printMaterialCode3" :key="index"
           class="prevent-page-break-inside">
        <table cellpadding="0" cellspacing="0">
          <tr>
            <td>
              <div class="ewm" :id="'qrCode3' + item.itemSn"/>
            </td>
            <td style="font-size:12px;">{{item.itemSn}}</td>
          </tr>
        </table>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button type="primary" v-print="printOption" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import QRCode from "qrcodejs2";

  export default {
    data() {
      return {
        dialogVisible: false,
        tableData: [],
        productInfo: {},
        printOption: {
          id: "printMaterialCodeContent3",
          preview: false,
          popTitle: "打印",
          previewPrintBtnLabel: "打印",
          clickMounted() {
          },
        },
      };
    },

    methods: {
      open(codeList, productInfo) {
        this.dialogVisible = true;
        this.tableData = codeList;
        this.productInfo = productInfo;
        for (let item of this.tableData) {
          const itemSn = item.itemSn;
          this.$nextTick(() => {
            document.getElementById("qrCode3" + itemSn).innerHTML = "";
            this.bindQRCode(itemSn);
          });
        }
      },

      bindQRCode(row) {
        let text = row;
        new QRCode(document.getElementById("qrCode3" + row), {
          text: text,
          width: 60,
          height: 60,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      },

      print() {
        this.$http.get("basic", `taskDispatchBills/updatePrintSn/${this.productInfo.pkid}`).then(() => {
        });

        return false;
      },
    },
  };
</script>

<style lang="scss">
#printMaterialCode3 {
  width: 34mm;
  height: 18mm;
  margin: 1mm auto;
  font-size: 10px;

  table {
    width: 100%;
    height: 100%;

    td {
      border: 1px solid #111;
      border-bottom: 0;
      border-right: 0;
      box-sizing: border-box;
      padding: 1px;

      .ewm {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    tr:first-child td:first-child {
      border-bottom: 1px solid #111;
    }

    tr:last-child td {
      border-bottom: 1px solid #111;
    }

    tr td:last-child {
      border-right: 1px solid #111;
    }
  }
}

@media print {
  .prevent-page-break-inside {
    page-break-inside: avoid;
  }

  #printMaterialCode3 {
    margin: 0;
  }

  @page {
    padding: 0.5mm;
  }
}
</style>
